module.exports = "<symbol id=\"tt-icon-quote\" viewBox=\"0 0 24 24\"><path d=\"M.28 14.81c0 4.11 2.65 6.44 5.62 6.44a5 5 0 0 0 5-5 4.29 4.29 0 0 0-4.3-4.54 3.11 3.11 0 0 0-1.26.19 11 11 0 0 1 4.93-6L6.79 3.13A14.36 14.36 0 0 0 .28 14.81zm12.88 0c0 4.11 2.59 6.44 5.56 6.44a5 5 0 0 0 5-5 4.27 4.27 0 0 0-4.23-4.55 3.11 3.11 0 0 0-1.26.19c.51-2.27 2.91-4.93 4.93-6l-3.55-2.76a14.3 14.3 0 0 0-6.44 11.68z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/v6J5ZUpvDmQ7AMLsite/assets/svg/comments-pinboard-page/quote.svg
// module id = 204
// module chunks = 11